import React, { useState, useEffect } from "react";
import axios from "axios";
import { fetchToken } from "../views/Auth"; // Ajuste o caminho se necessário

const SelectorEquipe = ({ selecionados = [], onChange }) => {
  const [busca, setBusca] = useState("");
  const [sugestoes, setSugestoes] = useState([]);
  const [usuariosSelecionados, setUsuariosSelecionados] = useState([]);
  const apiBaseUrl = "/api"; // Ajuste sua URL

  // Sincroniza se vierem dados pré-existentes (Edição)
  useEffect(() => {
    // Se 'selecionados' for apenas IDs, precisaríamos buscar os nomes,
    // mas por simplicidade, assumirei que o pai gerencia isso ou passaremos objetos completos.
    // Aqui vamos focar na lógica de IDs para envio.
    if (selecionados.length > 0 && usuariosSelecionados.length === 0) {
      // Lógica ideal: O pai passa objetos {id, name}. Se passar só ID, não mostra o nome inicial.
    }
  }, [selecionados]);

  // Busca Usuários na API
  useEffect(() => {
    if (busca.length < 3) {
      setSugestoes([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      const token = fetchToken();
      axios
        .get(`${apiBaseUrl}/projetocompleto/usuarios/busca?termo=${busca}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // Filtra os que já estão selecionados para não duplicar na lista
          const disponiveis = res.data.filter(
            (user) => !usuariosSelecionados.some((sel) => sel.id === user.id),
          );
          setSugestoes(disponiveis);
        })
        .catch((err) => console.error(err));
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [busca, usuariosSelecionados]);

  const adicionarUsuario = (usuario) => {
    if (usuariosSelecionados.length >= 6) {
      alert("Máximo de 6 membros na equipe.");
      return;
    }

    const novaLista = [...usuariosSelecionados, usuario];
    setUsuariosSelecionados(novaLista);
    setBusca("");
    setSugestoes([]);

    // Envia apenas os IDs para o componente pai (Formulário)
    const ids = novaLista.map((u) => u.id);
    onChange(ids);
  };

  const removerUsuario = (id) => {
    const novaLista = usuariosSelecionados.filter((u) => u.id !== id);
    setUsuariosSelecionados(novaLista);

    const ids = novaLista.map((u) => u.id);
    onChange(ids);
  };

  return (
    <div className="mb-3">
      <label className="form-label fw-bold">Equipe do Projeto (Máx 6)</label>

      {/* Área de Busca */}
      <div className="position-relative">
        <input
          type="text"
          className="form-control"
          placeholder="Digite o nome ou email para adicionar..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
        />

        {/* Dropdown de Sugestões */}
        {sugestoes.length > 0 && (
          <div
            className="list-group position-absolute w-100 shadow"
            style={{ zIndex: 1000, maxHeight: "200px", overflowY: "auto" }}
          >
            {sugestoes.map((user) => (
              <button
                key={user.id}
                type="button"
                className="list-group-item list-group-item-action"
                onClick={() => adicionarUsuario(user)}
              >
                <strong>{user.name}</strong>{" "}
                <small className="text-muted">({user.email})</small>
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Lista de Selecionados (Tags) */}
      <div className="d-flex flex-wrap gap-2 mt-2">
        {usuariosSelecionados.map((user) => (
          <div
            key={user.id}
            className="badge bg-primary d-flex align-items-center p-2 rounded-pill"
          >
            <span className="me-2">{user.name}</span>
            <button
              type="button"
              className="btn-close btn-close-white"
              style={{ width: "0.5rem", height: "0.5rem" }}
              onClick={() => removerUsuario(user.id)}
            ></button>
          </div>
        ))}
        {usuariosSelecionados.length === 0 && (
          <small className="text-muted fst-italic">
            Nenhum membro selecionado.
          </small>
        )}
      </div>
    </div>
  );
};

export default SelectorEquipe;
